import { render } from "./PickStoryCard.vue?vue&type=template&id=977caa4c&scoped=true"
import script from "./PickStoryCard.vue?vue&type=script&lang=js"
export * from "./PickStoryCard.vue?vue&type=script&lang=js"

import "./PickStoryCard.vue?vue&type=style&index=0&id=977caa4c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-977caa4c"]])

export default __exports__